// extracted by mini-css-extract-plugin
export default {"path":"LockIcon_path__SbuPC"};